import { CONTACT_TYPE_VALUES, valueMap } from "../platform/domain-values";

export const CONTACT_TYPES = valueMap(CONTACT_TYPE_VALUES);
export type ContactType = typeof CONTACT_TYPE_VALUES[number];

const SUPPLIER_TYPES: readonly string[] = [CONTACT_TYPES.supplier, CONTACT_TYPES.supplier_and_purchaser];
const PURCHASER_TYPES: readonly string[] = [CONTACT_TYPES.purchaser, CONTACT_TYPES.supplier_and_purchaser];

export function canActAsSupplier(contact: { contactType: string }): boolean {
  return SUPPLIER_TYPES.includes(contact.contactType);
}

export function canActAsPurchaser(contact: { contactType: string }): boolean {
  return PURCHASER_TYPES.includes(contact.contactType);
}
